"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitPreferencesFormStarted = exports.submitLoginInformationFormStarted = exports.userError = exports.updateUserEmail = exports.receiveUser = exports.receiveUserStarted = exports.SUBMIT_PREFERENCES_FORM_STARTED = exports.SUBMIT_LOGIN_INFORMATION_FORM_STARTED = exports.USER_ERROR = exports.UPDATE_USER_EMAIL = exports.RECEIVE_USER = exports.RECEIVE_USER_STARTED = void 0;
exports.default = reducer;
exports.loadUser = loadUser;
exports.getUserAndMembersAndTeamsAndProfileAndContactInfosAndHouseholds = getUserAndMembersAndTeamsAndProfileAndContactInfosAndHouseholds;
exports.submitLoginInformationForm = submitLoginInformationForm;
exports.submitPreferencesForm = submitPreferencesForm;
const validations_common_1 = require("components/form/validations-common");
const api_utils_1 = require("core/api-utils");
const cogsworth_1 = require("core/cogsworth");
const lodash_1 = require("lodash");
const redux_form_1 = require("redux-form");
// ducks
const app_1 = require("./app");
const contact_infos_1 = require("./contact-infos");
const households_1 = require("./households");
const members_1 = require("./members");
const profile_1 = require("./profile");
const teams_1 = require("./teams");
const api_1 = require("core/api");
const utils_1 = require("core/utils");
const app_2 = require("selectors/app");
const members_2 = require("selectors/members");
const profile_2 = require("selectors/profile");
// selectors
const user_1 = require("selectors/user");
const divisions_1 = require("./divisions");
// Actions
exports.RECEIVE_USER_STARTED = 'RECEIVE_USER_STARTED';
exports.RECEIVE_USER = 'RECEIVE_USER';
exports.UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
exports.USER_ERROR = 'USER_ERROR';
exports.SUBMIT_LOGIN_INFORMATION_FORM_STARTED = 'SUBMIT_LOGIN_INFORMATION_FORM_STARTED';
exports.SUBMIT_PREFERENCES_FORM_STARTED = 'SUBMIT_PREFERENCES_FORM_STARTED';
// Reducer
const initialState = {
    user: {},
    userLoaded: false,
};
function reducer(state = initialState, action = {}) {
    const user = action.data;
    switch (action.type) {
        case 'RECEIVE_USER_STARTED':
            return {
                ...state,
            };
        case 'RECEIVE_USER':
            return {
                ...state,
                userLoaded: true,
                user,
                hasTeams: user.activeTeamsCount > 0,
            };
        case 'UPDATE_USER_EMAIL':
            return {
                ...state,
                userLoaded: true,
                user: {
                    ...state.user,
                    email: action.data,
                },
            };
        case 'USER_ERROR':
            return {
                ...state,
                userLoaded: false,
                error: action.error,
            };
        case 'SUBMIT_LOGIN_FORM_STARTED':
            return {
                ...state,
            };
        case 'SUBMIT_PREFERENCES_FORM_STARTED':
            return {
                ...state,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveUserStarted = () => {
    return { type: exports.RECEIVE_USER_STARTED };
};
exports.receiveUserStarted = receiveUserStarted;
const receiveUser = (data) => {
    return { type: exports.RECEIVE_USER, data };
};
exports.receiveUser = receiveUser;
const updateUserEmail = (data) => {
    return { type: exports.UPDATE_USER_EMAIL, data };
};
exports.updateUserEmail = updateUserEmail;
const userError = (data) => {
    return { type: exports.USER_ERROR, data };
};
exports.userError = userError;
const submitLoginInformationFormStarted = () => {
    return { type: exports.SUBMIT_LOGIN_INFORMATION_FORM_STARTED };
};
exports.submitLoginInformationFormStarted = submitLoginInformationFormStarted;
const submitPreferencesFormStarted = () => {
    return { type: exports.SUBMIT_PREFERENCES_FORM_STARTED };
};
exports.submitPreferencesFormStarted = submitPreferencesFormStarted;
// services
function loadUser(returnForSignup) {
    return (dispatch) => {
        dispatch((0, exports.receiveUserStarted)());
        return api_1.UserService.showUser(true)
            .then((data) => {
            dispatch((0, exports.receiveUser)(data));
        })
            .catch((error) => {
            error?.status === 403 && (0, utils_1.redirectToLogin)(false, undefined, returnForSignup);
            dispatch((0, exports.userError)(error));
        });
    };
}
function getUserAndMembersAndTeamsAndProfileAndContactInfosAndHouseholds() {
    return (dispatch, getState) => {
        return dispatch(loadUser())
            .then(() => {
            const user = (0, user_1.getUser)(getState());
            if (user) {
                return dispatch((0, profile_1.loadProfile)()).then(() => {
                    const profileUuid = (0, profile_2.currentProfileUuid)(getState());
                    if (profileUuid) {
                        return dispatch((0, contact_infos_1.loadContactInfos)(profileUuid)).then(() => {
                            return dispatch((0, households_1.loadHouseholds)()).then(() => {
                                return dispatch((0, members_1.loadMembers)(user)).then(() => {
                                    dispatch((0, teams_1.loadTeams)((0, members_2.memberTeamIds)(getState())));
                                    dispatch((0, divisions_1.loadDivisions)((0, members_2.memberDivisionIds)(getState())));
                                });
                            });
                        });
                    }
                    else {
                        return dispatch((0, members_1.loadMembers)(user)).then(() => {
                            return dispatch((0, teams_1.loadTeams)((0, members_2.memberTeamIds)(getState()))).then(() => { });
                        });
                    }
                });
            }
        })
            .catch((error) => {
            console.log('error initializing', error);
            setTimeout(getUserAndMembersAndTeamsAndProfileAndContactInfosAndHouseholds, 5000);
        });
    };
}
function submitLoginInformationForm(data) {
    const successText = 'Your login info has been updated';
    const errorText = 'Failed to update your login info';
    return (dispatch, getState) => {
        dispatch((0, exports.submitLoginInformationFormStarted)());
        // form validation lives here. We want it to be done after save has been clicked
        // but before the api calls go out. This form does have api response errors
        // to validate the current password is correct and email isn't already in use
        // (if you change it, but those validations are done in the api call/response
        const formErrors = (0, validations_common_1.validateLoginFormFields)(data);
        // if we're showing the save needed model, skip specific form errors and send them back to the working form
        if (!(0, app_2.showSaveNeeded)(getState())) {
            if (!(0, lodash_1.isEmpty)(formErrors)) {
                dispatch((0, app_1.appFeedbackMessageError)(errorText));
                throw new redux_form_1.SubmissionError(formErrors);
            }
        }
        return (0, cogsworth_1.patchUser)(data)
            .then((res) => {
            // response here is just the email address
            dispatch((0, exports.updateUserEmail)(res));
            return dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
        })
            .catch((errorRes) => {
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
            if ((0, app_2.showSaveNeeded)(getState())) {
                const rejectedPromise = new Promise((_resolve, reject) => {
                    // eslint-disable-line no-unused-vars
                    setTimeout(() => {
                        reject('login form reject Save Needed');
                    }, 1000);
                });
                return rejectedPromise;
            }
            if (errorRes.validationErrors) {
                throw new redux_form_1.SubmissionError((0, api_utils_1.formatValidationErrors)(errorRes.validationErrors));
            }
        });
    };
}
function submitPreferencesForm(data) {
    return (dispatch, getState) => {
        dispatch((0, exports.submitPreferencesFormStarted)());
        return api_1.UserService.updateUser(data)
            .then((data) => {
            const successText = 'Your preferences have been updated';
            dispatch((0, exports.receiveUser)(data));
            return dispatch((0, app_1.appFeedbackMessageSuccess)(successText));
        })
            .catch((errorRes) => {
            // changed this since the original error commented below didn't make sense
            // 'Failed to update your login info';
            const errorText = 'Failed to update your preferences';
            dispatch((0, app_1.appFeedbackMessageError)(errorText));
            if (!(0, app_2.showSaveNeeded)(getState()) && errorRes.validationErrors) {
                throw new redux_form_1.SubmissionError((0, api_utils_1.formatValidationErrors)(errorRes.validationErrors));
            }
            const rejectedPromise = new Promise((_resolve, reject) => {
                // eslint-disable-line no-unused-vars
                setTimeout(() => {
                    reject('reject Save Needed');
                }, 1000);
            });
            return rejectedPromise;
        });
    };
}
// base rejected Promise. This is used for the saveNeeded window. If a save button
// is clicked, it will wait to make sure the submit was successful. If it is not,
// we need to return a rejected promise so the saveNeeded window knows to trigger
// the onSaveError function
